import { useMutation, useQueryClient } from 'react-query';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';

interface UpdateOnboardingStepRequest {
  step: string;
  status: 'pending' | 'in_progress' | 'completed';
}

export const useUpdateOnboardingStep = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ step, status }: UpdateOnboardingStepRequest) => dataFetch.patch(
      `${CORE_API_SUFFIX}digger-core-api/onboarding/steps/${step}`,
      { status },
    ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['onboarding-steps']);
      },
    },
  );
};
